import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import bootstrap from 'state/bootstrap';
import ShortcutProvider from './ShortcutProvider';
import Routes from 'routes/Routes';

export default class Root extends Component {
    state = {
        bootstrapped: false,
    };

    componentDidMount() {
        bootstrap(this.props.store.dispatch).then(() => {
            this.setState({ bootstrapped: true });
        });
    }

    render() {
        const { store, history } = this.props;

        return (
            <Provider store={store} key="provider">
                <div style={{ height: '100%', width: '100%' }}>
                    <ShortcutProvider key="shortcutProvider">
                        <Routes
                            history={history}
                            bootstrapped={this.state.bootstrapped}
                        />
                    </ShortcutProvider>
                    <ReduxToastr
                        key="whatever"
                        timeOut={10000}
                        newestOnTop={false}
                        preventDuplicates={true}
                        position="top-right"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        showCloseButton="true"
                    />
                </div>
            </Provider>
        );
    }
}

Root.propTypes = {
    store: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};
